import React, { useCallback, useEffect, useReducer, useState } from "react"
import { obterResultadosPesquisa } from "../../../services/pesquisaSatisfacao"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { PesquisaSatisfacaoFornecedorActionsTypes } from "./pesquisaSatisfacaoFornecedorActions"
import { PesquisaSatisfacaoFornecedorContext } from "./PesquisaSatisfacaoFornecedorContext"
import {
    PesquisaSatisfacaoFornecedorInicial,
    pesquisaSatisfacaoFornecedorReducer,
} from "./pesquisaSatisfacaoFornecedorReducer"

export function PesquisaSatisfacaoFornecedorContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [dados, dispatch] = useReducer(
        pesquisaSatisfacaoFornecedorReducer,
        PesquisaSatisfacaoFornecedorInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const pesquisar = useCallback(
        async (inicio?: number, fim?: number) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            const inicioParaUsar = inicio ?? dados.inicioMs
            const fimParaUsar = fim ?? dados.fimMs
            try {
                setLoading(true)
                const response = await obterResultadosPesquisa(
                    autorizacao,
                    inicioParaUsar,
                    fimParaUsar
                )
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao carregar resultados")
                } else {
                    setErroCarregamento(null)
                    dispatch({
                        type: PesquisaSatisfacaoFornecedorActionsTypes.CARREGAR,
                        payload: response,
                    })
                }
            } catch {
                setErroCarregamento("Erro ao carregar resultados")
            } finally {
                setLoading(false)
            }
        },
        [dados.inicioMs, dados.fimMs]
    )

    useEffect(() => {
        pesquisar()
    }, [])

    return (
        <PesquisaSatisfacaoFornecedorContext.Provider
            value={{ dados, dispatch, pesquisar, erroCarregamento }}
        >
            <Loading />
            {children}
        </PesquisaSatisfacaoFornecedorContext.Provider>
    )
}
